import { gql } from '@apollo/client';
import Fragments from './fragments';

export const REPORT_UPDATED = gql`
  subscription reportUpdated {
    reportUpdated {
      report {
        ...reportItem
        reportXDocumentTypes {
          ...reportXDocumentTypeItem
        }
        reportXPartnerTypes {
          ...reportXPartnerTypeItem
        }
      }
    }
  }
  ${Fragments.reportItem}
  ${Fragments.reportXDocumentTypeItem}
  ${Fragments.reportXPartnerTypeItem}
`;

export const REPORT_PARAMETER_UPDATED = gql`
  subscription reportParameterUpdated {
    reportParameterUpdated {
      reportParameter {
        ...reportParameterItem
      }
    }
  }
  ${Fragments.reportParameterItem}
`;

export const REPORT_PARAMETER_REMOVED = gql`
  subscription reportParameterRemoved {
    reportParameterRemoved {
      reportParameterId
      reportId
    }
  }
`;

export const REPORT_FILTER_UPDATED = gql`
  subscription reportFilterUpdated {
    reportFilterUpdated {
      reportFilter {
        ...reportFilterItem
      }
    }
  }
  ${Fragments.reportFilterItem}
`;

export const REPORT_FILTER_REMOVED = gql`
  subscription reportFilterRemoved {
    reportFilterRemoved {
      filterId
      reportId
    }
  }
`;

export const REPORT_X_USER_GROUPS_UPDATED = gql`
  subscription reportXUserGroupsUpdated {
    reportXUserGroupsUpdated {
      reportXUserGroups {
        ...reportXUserGroupItem
      }
      reportId
    }
  }
  ${Fragments.reportXUserGroupItem}
`;
